import {
  SKIP_LAYER_PATTERNS,
  TRAFFIC_LAYER_PATTERNS,
} from './GlobalMapSearch.constants';

export interface ViewportExtent {
  xmin: number;
  ymin: number;
  xmax: number;
  ymax: number;
  spatialReference?: { wkid?: number; isWebMercator?: boolean };
}

export function shouldSkipLayer(title: string): boolean {
  const lower = title.toLowerCase();
  return SKIP_LAYER_PATTERNS.some(p => lower.includes(p));
}

/**
 * Traffic-style layers (live traffic, traffic incidents, road closures) are
 * world-scale services. We bound them to the user's current viewport rather
 * than the jurisdiction polygon so results are relevant to what they're
 * actually looking at on the map.
 */
export function isTrafficLayer(...titles: (string | undefined)[]): boolean {
  return titles.some(t => {
    if (!t) return false;
    const lower = t.toLowerCase();
    return TRAFFIC_LAYER_PATTERNS.some(p => lower.includes(p));
  });
}

/**
 * Snapshot the current ArcGIS view extent. Returns null if the map isn't
 * mounted yet or the view hasn't reported an extent (e.g. mid-transition).
 */
export function getViewportExtent(): ViewportExtent | null {
  const view = (
    window as Window & {
      __RSOS?: { map?: { mapInstance?: { view?: { extent?: unknown } } } };
    }
  ).__RSOS?.map?.mapInstance?.view;
  const extent = view?.extent as
    | {
        xmin?: number;
        ymin?: number;
        xmax?: number;
        ymax?: number;
        spatialReference?: { wkid?: number; isWebMercator?: boolean };
      }
    | undefined;
  if (
    !extent ||
    typeof extent.xmin !== 'number' ||
    typeof extent.ymin !== 'number' ||
    typeof extent.xmax !== 'number' ||
    typeof extent.ymax !== 'number'
  ) {
    return null;
  }
  return {
    xmin: extent.xmin,
    ymin: extent.ymin,
    xmax: extent.xmax,
    ymax: extent.ymax,
    spatialReference: extent.spatialReference,
  };
}
